import React, { FunctionComponent } from "react"

const SkeletonCard: FunctionComponent = () => (
    <div className="wn-skeleton">
        <div className="wn-skeleton__image" />
        <div className="wn-skeleton__body">
            <div className="wn-skeleton__line wn-skeleton__line--short" />
            <div className="wn-skeleton__line wn-skeleton__line--full" />
            <div className="wn-skeleton__line wn-skeleton__line--medium" />
        </div>
    </div>
)

export const WhatsNewSkeletons: FunctionComponent = () => (
    <>
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
    </>
)
